import { writable } from "svelte/store";

export const config = writable ({
    createdDate: null,
    inmateLabelName: "Prisoner",
    keyworkerLabelName: "Keyworker",
    establishmentName: "",
    footerText: "OFFICIAL - SENSITIVE",

    showSiteName: true,
    showReligionFilter: true,
    showCellStatusIcon: true,
    numberOfDaysConsideredNewSite: 14,
    numberOfDaysConsideredNewInmate: 3,
    numberOfDaysConsideredNewCircumstance: 4,
    numberOfDaysToShowTemporaryDischarge: null,
    trendPastDaysToAnalyse: 7,

    isolationPastDaysToAnalyse: 180,
    isolationNumberOfDaysConsideredNewLevel: 3,
    isolationLackOfEngagementElementThreshold: 0,
    isolationRegimeStopDate: null,
    isolationTargetedMinimumHighLevels: 3,
    isolationTargetedThresholdScore: 22,

    isolationVisitWeighting: 100,
    isolationWorkWeighting: 100,
    isolationPhoneWeighting: 100,
    isolationMealWeighting: 100,
    isolationGymWeighting: 100,
    isolationPaWeighting: 100,
    isolationCanteenWeighting: 100,

    isolationVisitLabel: "Visits",
    isolationWorkLabel: "Work",
    isolationPhoneLabel: "Phone",
    isolationMealLabel: "Meals",
    isolationGymLabel: "Gym",
    isolationPaLabel: "Activities",
    isolationCanteenLabel: "Canteen",

    isolationVisitDescription: "Visits",
    isolationWorkDescription: "Work/Education Sessions",
    isolationPhoneDescription: "Phone Top Ups",
    isolationMealDescription: "Meal Selections",
    isolationGymDescription: "Gym",
    isolationPaDescription: "Other Purposeful Activities",
    isolationCanteenDescription: "Canteen Spend",

    surveyUrn: 0,
    surveyPercentageThresholdTargeted: 0,
    surveyPercentageThresholdHigh: 0,
    surveyPercentageThresholdMedium: 0,
    surveyPastDaysToAnalyse: 0,
    surveyLabelName: "Wellbeing",
    surveyDefaultTotal: 0,
    surveyDefaultFrequency: 0,
    surveyAutoScheduleOnArrival: false,
    surveyAutoScheduleOnArrivalDelayDays: 0,

    triggerDatesLabelName: "",
    triggerDatesDescription: "",
    triggerDatesPastDaysToAnalyse: 0,
    triggerDatesFutureDaysToAnalyse: 0,
    triggerDatesChecklistUrn: 0,

    contactTypeId: 0,
    contactReviewDateDefaultPeriod: 0,
    
    earlyDaysLabelName: null,
    numberOfDaysConsideredEarlyDaysPeriod: 0,
    earlyDaysTargetedMinimumHighLevels: null,
    earlyDaysTargetedThresholdScore: null,
    earlyDaysVisit: true,
    earlyDaysWork: true,
    earlyDaysPhone: true,
    earlyDaysMeal: true,
    earlyDaysGym: true,
    earlyDaysPa: true,
    earlyDaysCanteen: true,
    earlyDaysNumberOfDaysToIgnoreTargeting: 0,

    riskFactorChecklistUrn: 0,
    riskFactorPercentageThresholdTargeted: 0,
    riskFactorPercentageThresholdHigh: 0,
    riskFactorPercentageThresholdMedium: 0,
    riskFactorLabelName: "Risk Factors",

    earlyRiskAssessmentLabelName: "",
    earlyRiskAssessmentDescription: "",
    earlyRiskFlagLabelName: "",
    earlyRiskFlagDescription: "",
    earlyRiskNumberOfHoursPeriod: 0,
    earlyRiskChecklistUrn: 0,
    
    inmatePeriodOfStayOrdering: "",
});

export const countActiveIsolationElements = (config) => {
    let count = 0;
    count += (config.isolationVisitWeighting === 0) ? 0 : 1;
    count += (config.isolationWorkWeighting === 0) ? 0 : 1;
    count += (config.isolationPhoneWeighting === 0) ? 0 : 1;
    count += (config.isolationMealWeighting === 0) ? 0 : 1;
    count += (config.isolationCanteenWeighting === 0) ? 0 : 1;
    count += (config.isolationGymWeighting === 0) ? 0 : 1;
    count += (config.isolationPaWeighting === 0) ? 0 : 1;
    return count;
}

export const countActiveEarlyDaysElements = (config) => {
    let count = 0;
    count += config.earlyDaysVisit ? 1 : 0;
    count += config.earlyDaysWork ? 1 : 0;
    count += config.earlyDaysPhone ? 1 : 0;
    count += config.earlyDaysMeal ? 1 : 0;
    count += config.earlyDaysCanteen ? 1 : 0;
    count += config.earlyDaysGym ? 1 : 0;
    count += config.earlyDaysPa ? 1 : 0;
    return count;
}